import { WHISLIST_DATA } from "../Type/type";
  
  export const whislistDataAction = (data) => {
    return {
      type: WHISLIST_DATA,
      payload: data,
    };
  };